import { render, staticRenderFns } from "./Prize.vue?vue&type=template&id=4e912c52&scoped=true"
import script from "./Prize.vue?vue&type=script&lang=js"
export * from "./Prize.vue?vue&type=script&lang=js"
import style0 from "./Prize.vue?vue&type=style&index=0&id=4e912c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e912c52",
  null
  
)

export default component.exports